<template>
  <popper
      trigger="hover"
      :options="{
                  placement: placement,
                  modifiers: { offset: { offset: '0,10px' } }
                }">
    <div @click="$emit('onClick')" class="popper" v-html="hoverText" v-if="showAsHtml"></div>
    <div @click="$emit('onClick')" class="popper" v-else>{{ hoverText }}</div>
    <div @click="$emit('onClick')" slot="reference" :class="classes" :style="styles">
      <span v-if="!textBelow">{{ value }}</span> <i :class="`${iconValue}`"></i>
      <span v-if="textBelow"><br>{{ value }}</span>
    </div>
  </popper>

</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

export default {
  name: "ks-popover",
  mixins: [checkPermissions],
  props: {
    placement: {
      type: String,
      required: false,
      default: 'top'
    },
    abbreviated: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: false
    },
    hoverText: {
      type: String,
      required: false,
      default: ''
    },
    showAsHtml: {
      type: Boolean,
      default: false
    },
    textBelow: {
      type: Boolean,
      default: false
    },
    iconValue: {
      type: String,
      default: null
    },
    classes: {
      type: String,
      default: null
    },
    styles: {
      type: String,
      default: null
    },
  },
  mounted() {
  },
  computed: {},
  components: {
    'popper': Popper
  },
  data() {
    return {}
  }
}
</script>
